export enum SciView {
  Compact = 'compact',
  Normal = 'normal',
}
